import { expiryState } from '@l2u/ui/lib/expiry.ts';

// State-only chip (the dates render in the card's meta row, so unlike
// ExpiryChip this shows just the health label).
export function UploadStateChip({ expiresAt, now }: { expiresAt: string | null; now: Date }) {
  const state = expiryState({ expires_at: expiresAt }, now);
  if (state === 'expired') {
    return (
      <span className="shrink-0 rounded-full bg-red-100 px-2 py-0.5 text-xs font-medium text-red-700">
        Expired
      </span>
    );
  }
  if (state === 'expiring') {
    return (
      <span className="shrink-0 rounded-full bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-800">
        ⚠ Expiring Soon
      </span>
    );
  }
  return (
    <span className="shrink-0 rounded-full bg-emerald-50 px-2 py-0.5 text-xs font-medium text-emerald-700">
      ✓ Current
    </span>
  );
}
